/** Radio máximo de acción al crear encuentros / elegir lugares (km). */
export const DEFAULT_ACTION_RADIUS_KM = 100;

const PLAN_ACTION_RADIUS_KM = {
  free: 100,
  intimate: 100,
  obsidian: 100,
  curioso: 25,
  conectado: 75,
  activo: 150,
  vip: 100,
};

/**
 * Radio de acción según plan (para situar encuentros y listar lugares).
 * No confundir con el radio del mapa (preferencia de visualización).
 */
export function getActionRadiusKm(planId) {
  const km = PLAN_ACTION_RADIUS_KM[planId] ?? DEFAULT_ACTION_RADIUS_KM;
  return Math.max(km, DEFAULT_ACTION_RADIUS_KM);
}
